<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  props: {
    id: {
      default: null,
    },
  },
  created() {
    this.itemLink = `dealers/${this.id}/transactions`;
    this.setLink = `dealers/${this.id}/transactions`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "status",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "value",
          label: "Значение",
          type: "field",
          textType: "number",
        },

        {
          col: " col-12 col-md-12",
          key: "status",
          label: "Вид",
          type: "select",
          modal: "status_transaction",
          selectKey: "title",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_transaction",
      itemLink: "transactions",
      setLink: "transactions",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy: "id",
        },
        {
          key: "title",
          title: "Элемент",
        },
        {
          key: "value",
          title: "Бонус",
        },
        {
          key: "is_confirm",
          title: "Подтвержден",
        },
        {
          key: "barcode",
          title: "С/Н",
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
